import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartBar,
  faUsers,
  faCog,
  faBuilding,
  faUserCog,
  faFileAlt,
  faTools,
  faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons';

const ReportCard = ({ report, onClick }) => {
  const getReportIcon = (iconName) => {
    const iconMap = {
      'users': faUsers,
      'tools': faTools,
      'chart-bar': faChartBar,
      'file-alt': faFileAlt,
      'cog': faCog,
      'building': faBuilding,
      'user-cog': faUserCog
    };
    return iconMap[iconName] || faChartBar;
  };

  const getCategoryBadgeColor = (category) => {
    switch (category) {
      case 'system':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
      case 'business':
        return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
      case 'custom':
        return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
    }
  };

  return (
    <div 
      className="group bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6 cursor-pointer hover:shadow-lg hover:border-blue-300 dark:hover:border-blue-600 transition-all duration-200"
      onClick={onClick}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
            <FontAwesomeIcon 
              icon={getReportIcon(report.icon)} 
              className="text-white text-lg" 
            />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white text-lg group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
              {report.displayName}
            </h3>
            <span className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${getCategoryBadgeColor(report.category)}`}>
              {report.category}
            </span>
          </div>
        </div>
        <FontAwesomeIcon 
          icon={faExternalLinkAlt} 
          className="text-gray-400 group-hover:text-blue-500 transition-colors opacity-0 group-hover:opacity-100" 
        />
      </div>

      {/* Description */}
      <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 line-clamp-3">
        {report.description}
      </p>

      {/* Tags */}
      {report.tags && report.tags.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-4">
          {report.tags.slice(0, 4).map(tag => (
            <span
              key={tag}
              className="text-xs px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded-full"
            >
              {tag}
            </span>
          ))}
          {report.tags.length > 4 && (
            <span className="text-xs text-gray-500 dark:text-gray-500 px-2 py-1">
              +{report.tags.length - 4} more
            </span>
          )}
        </div>
      )}

      {/* Footer */}
      <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 pt-4 border-t border-gray-100 dark:border-gray-700">
        <span>{report.name}</span>
        <span className="group-hover:text-blue-500 transition-colors">
          Click to view →
        </span>
      </div>
    </div>
  );
};

export default ReportCard;